import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private globle: Globle,
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService) { }


  login(obj: any) {
    const httpOptions = {
      withCredentials: true
    };
    return this.http.post<any>(this.globle.APIURL + "identity/loginadmin", obj,
      httpOptions)
  }

  changePassword(obj: any) {
    return this.http.post<any>(this.globle.APIURL + "identity/changepassword", obj)
  }

  resetPassword(obj: any) {
    return this.http.post<any>(this.globle.APIURL + "identity/adminresetpassword", obj)
  }

  loggedIn() {
    return !!this.localStorage.retrieve("token");
  }

  logout() {
    this.localStorage.clear();
    this.sessionStorage.clear();
    window.location.href = "";
  }

  checkUserActive() {
    var userId = this.localStorage.retrieve("userInfo").userId;
    return this.http.get<any>(this.globle.APIURL + "users/checkuseractive?userId=" + userId);
  }

  getAuthToken() {
    var token = this.localStorage.retrieve("token");
    return token

  }
}
